import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';
const SvgArrowRight = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "m13.45 5.403 6.284 5.979a.853.853 0 0 1 0 1.237l-6.285 5.978a.86.86 0 0 1-1.212-.029.85.85 0 0 1 .03-1.208l4.738-4.505H4.857A.856.856 0 0 1 4 12.001c0-.472.384-.854.857-.854h12.146l-4.74-4.505a.856.856 0 0 1-.028-1.21c.329-.342.84-.354 1.214-.03"
    }));
export default SvgArrowRight;
